/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./StepProgress.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-stepProgress");
exports.StepProgress = function StepProgress(_a) {
    var current = _a.current, total = _a.total;
    var progress = 0;
    var indicatorWidth = 0;
    if (current !== undefined && total !== undefined) {
        // Progress must be between 0 and 100
        progress = Math.max(0, Math.min(100, (100 / total) * current));
        indicatorWidth = (1 - (((current - 1) / total) * 100) / progress) * 100;
    }
    return (React.createElement("div", { className: classnames(moduleClassName(), total === undefined && moduleClassName("hasUnknownTotal")) },
        React.createElement("div", { className: moduleClassName("inner"), style: { width: progress + "%" } },
            React.createElement("div", { className: moduleClassName("active"), style: { width: indicatorWidth + "%" } }))));
};
exports.StepProgress.propTypes = {
    current: PropTypes.number,
    total: PropTypes.number
};